import React from "react";
import useTabId from "hooks/dashboard/useTabId";
import useDashboardStore from "store/dashboard-store";
import { ProgressSpinner } from "primereact/progressspinner";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import DashboardTabGroup from "./DashboardTabGroup";
import { onDragEndSplice, updateDashboardTabs } from "../../utils";

const DashboardTab = () => {
  const tabId = useTabId();
  const dashboard = useDashboardStore(state => state.dashboard);
  const getTab = useDashboardStore(state => state.getTab);
  const isGroupReorderEnabled = useDashboardStore(state => state.isGroupReorderEnabled);

  const onDragEnd = (result: any) => {
    if (!result.destination || !dashboard) return;

    const reorderedGroups = onDragEndSplice(
      result,
      dashboard.dashboardTabsJs[tabId].componentGroups
    );

    updateDashboardTabs(
      dashboard,
      dashboard.dashboardTabsJs.map((tab, index) =>
        index === tabId ? { ...tab, componentGroups: reorderedGroups } : tab
      )
    );
  };

  if (!dashboard) {
    return <ProgressSpinner />;
  }

  const currentTab = getTab(tabId);

  if (!currentTab) {
    return <div>Tab not found</div>;
  }

  return (
    <div>
      {isGroupReorderEnabled ? (
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="groups" direction="horizontal">
            {providedDrop => (
              <div {...providedDrop.droppableProps} ref={providedDrop.innerRef}>
                {dashboard.dashboardTabsJs[tabId].componentGroups.map((group, index) => (
                  <Draggable key={group.id} draggableId={group.id} index={index}>
                    {provided => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                        }}
                      >
                        <DashboardTabGroup key={group.id} group={group} tabId={tabId} />
                      </div>
                    )}
                  </Draggable>
                ))}
                {providedDrop.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      ) : (
        <div>
          {currentTab.componentGroups?.map(group => (
            <DashboardTabGroup key={group.id} group={group} tabId={tabId} />
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardTab;
